















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Swiper from 'swiper';

import { Poi, PoiState } from '@/models/poi';
import PoiGalleryItems from '@/components/poi-gallery-items.vue';

@Component({
    components: {
        PoiGalleryItems
    },
})
export default class PoiMediaGallery extends Vue {

    @Prop(Object) public poi: Poi;

    public swiper: Swiper;
    public activeIndex: number;
    public hideCaptions = false;

    get locked() {
        return this.poi.state !== PoiState.UNLOCKED;
    }

    public mounted() {
        // @ts-ignore
        this.swiper = this.$refs.gallerySlider.swiper as Swiper[];

        // @ts-ignore
        this.swiper.on('tap', this.slideTapped);
        this.swiper.on('slideChange', this.slideChanged);
        this.$root.$on('fullscreenSlideChanged', this.onFullscreenSlideChanged);
    }

    public beforeDestory() {
        // @ts-ignore
        this.swiper.off('tap', this.slideTapped);
        this.swiper.off('slideChange', this.slideChanged);
        this.$root.$off('fullscreenSlideChanged', this.onFullscreenSlideChanged);
    }

    @Watch('poi')
    public async updateGallery() {
        await this.$nextTick();
        // @ts-ignore
        this.$refs.gallerySlider.swiper.update();
    }

    public onFullscreenSlideChanged(slideIndex: number) {
        const slideCount = this.swiper && this.swiper.slides && this.swiper.slides.length || 0;
        if (slideCount <= 0 || slideIndex < 0 || slideIndex >= slideCount) return;

        this.swiper.slideTo(slideIndex);
    }

    public slideChanged() {
        const gallerySlider = this.$refs.gallerySlider as Vue;
        for (const childComponent of gallerySlider.$children) {
            const child = childComponent as any;
            if (typeof child.onSlideChanged === 'function') {
                child.onSlideChanged();
            }
        }
    }

    public slideTapped(event: Event) {
        const tagName = (event.srcElement as any).tagName;
        const isTouchEvent = event instanceof TouchEvent;
        const isPlayer = (event.srcElement as any).classList.contains('audio-container');
        const isTargetTag = tagName === 'P' || tagName === 'IMG' || isPlayer;
        if (isTouchEvent && isTargetTag) {
            this.toggleCaptionVisibility();
        }
    }

    public toggleCaptionVisibility() {
        this.hideCaptions = !this.hideCaptions;
    }

    public openFullscreen() {
        this.$f7router.navigate(`/pois/${this.poi.id}/fullscreen-slider/`, {
            props: {
                slideId: this.swiper.activeIndex,
            }
        });
    }
}
